// extracted by mini-css-extract-plugin
export default {"container":"form-body_container","privacyNote":"form-body_privacyNote","privacyNoteIcon":"form-body_privacyNoteIcon"};